export default "__VITE_ASSET__BMk$rCtP__"